import cx from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import FilterIcon from './FilterIcon'

export type SearchControlProps = {
  styles?: React.CSSProperties
  onClick?: () => void
  active?: boolean
}

function SearchControl({ onClick, active }: SearchControlProps) {
  const { t } = useTranslation()

  return (
    <StyledControl id="filter-control">
      <button
        title={t('dashboard:search device')}
        onClick={onClick}
        className={cx({ active: active })}>
        <FilterIcon color="#fff" />
      </button>
    </StyledControl>
  )
}

const StyledControl = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  border-radius: 4px;
  cursor: pointer !important;
  background-color: #fff;
  width: 32px;
  min-height: 32px;

  button {
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    color: #fff;
    background-color: #0486ff;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgb(0 0 0 / 30%);
    cursor: pointer !important;

    &.active,
    &:hover {
      background-color: #ffe288;
      color: #0074a8;

      svg g {
        stroke: #0074a8;
      }
    }
  }
`

export default React.memo(SearchControl)
